
import LazyLoad from "vanilla-lazyload";

const init = () => {
  let lazyLoadInstance = new LazyLoad({
  });

  lazyLoadInstance.update();

};

export default init;
